<div class="container-modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-left">
      <img src="assets/svg/awards/calendar-red.svg" alt="glosario" class="header-icon">
      <h1 class="modal-title">{{ data.title || 'Glosario de términos' }}</h1>
    </div>
    <button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="modal-content">
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-state">
      <div class="skeleton-content">
        <div class="skeleton-text mb-3">
          <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '20px', width: '80%' }"></ngx-skeleton-loader>
        </div>
        <div class="skeleton-accordion">
          <div *ngFor="let item of [1,2,3,4,5,6,7]" class="skeleton-item mb-2">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%' }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Error state -->
    <div *ngIf="error" class="error-state">
      <h3 class="error-title">Algo salió mal</h3>
      <p class="error-description">Lo sentimos, no pudimos mostrar el Glosario de términos, vuelve a intentarlo en unos minutos.</p>
      <button class="error-retry-button" (click)="loadGlossaryData()">
        Reintentar
        <img src="assets/image/recognitions/reload.svg" alt="reload" class="reload-icon">
      </button>
    </div>
    
    <!-- Content state -->
    <div *ngIf="!loading && !error && glossaryData.length > 0" class="glossary-content">
      <p class="intro-text">Este glosario te ayudará a entender los <strong>conceptos clave</strong> <span class="bold-text"> usados en la tabla de Reconocimientos.</span></p>
      
      <mat-accordion class="glossary-accordion">
        <mat-expansion-panel *ngFor="let item of glossaryData" class="glossary-panel">
          <mat-expansion-panel-header class="glossary-header">
            <mat-panel-title class="glossary-term">{{ formatTerm(item.term) }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="glossary-definition" [innerHTML]="item.definition"></div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    
    <!-- Empty state -->
    <div *ngIf="!loading && !error && glossaryData.length === 0" class="empty-state">
      <mat-icon class="empty-icon">info_outline</mat-icon>
      <p>No hay términos disponibles en el glosario.</p>
    </div>
  </div>
</div>